import { addAsset } from "./utilities";

// ===============================================================
// CART DRAWER
// ===============================================================
// export function setCartDrawer() {
//   window.addEventListener('load', () => {

//     // Seleciona o elemento
//     const root = document.querySelector('#component-cart-drawer-root');

//     // Inicia o componente
//     const componentCartDrawer = new Vnda.Component.CartDrawer({
//       version: 'v16',
//       display: 'list',
//       startOpen: false,
//       anchor: 'right',
//       freeShipping: false,
//       disableShippingCalculation: true,
//     });

//     // Renderiza o componente
//     componentCartDrawer.render(root);

//     // Adiciona o evento de abertura
//     let open = document.querySelector('[data-toggle-cart]');
//     if (open) open.addEventListener('click', componentCartDrawer.toggle);

//     let open_mobile = document.querySelector('[data-toggle-cart-mobile]');
//     if (open_mobile) open_mobile.addEventListener('click', componentCartDrawer.toggle);

//     // Adiciona o componente ao escopo global
//     window.componentCartDrawer = componentCartDrawer;

//   });
// }

export const CartDrawer = {
  root: document.querySelector('#component-cart-drawer-root'),
  buttons: document.querySelectorAll('[data-toggle-cart]'),
  countWrapper: document.querySelector('[data-cart-count]'),
  settings: window.cartDrawerSettings || false,
  instance: false,

  setCartDrawer: function() {
    const { settings, root } = CartDrawer;

    if (!root || !settings) return;
  
    // Define frete grátis
    const freeShipping = (settings.freeShippingValue > 1) ? settings.freeShippingValue : 0

    // Inicia o componente
    const componentCartDrawer = new Vnda.Component.CartDrawer({
      anchor: 'right',
      display: 'list',
      startOpen: false,
      titleCart: 'Carrinho de compras',
      disableShippingCalculation: false,
      freeShipping
    });

    // Renderiza o componente
    componentCartDrawer.render(root);

    // Salva instância em propriedade local
    CartDrawer.instance = componentCartDrawer;

    // dispara evento de carregamento, escutado por CartDrawer.show()
    root.dispatchEvent(new Event('vnda:cart-drawer-loaded'))
  },

  loadComponent: function() {
    const { settings } = CartDrawer;
    addAsset(settings.script, CartDrawer.setCartDrawer);
    addAsset(settings.styles);
  },

  handleCartButton: function(button) {
    // Evita múltiplos cliques caso o carrinho precisa ser instanciado primeiro
    if (button.classList.contains('-loading')) {
      return;
    }

    // Abre o cart drawer
    button.classList.add('-loading');
    CartDrawer.show(() => { button.classList.remove('-loading') })
  },

  show: function (callback) {

    const { root } = CartDrawer;

    // No mobile, fecha o menu primeiro
    if (window.mmenu) window.mmenu.close()

    // Instancia o componente, caso ainda não exista
    if (!CartDrawer.instance) CartDrawer.loadComponent();

    // Observa criação da instância inicial, caso não tenha
    if (CartDrawer.instance === false) {
      root.addEventListener('vnda:cart-drawer-loaded', () => {
        CartDrawer.instance.open()
        if (typeof callback === 'function') callback()
      })
    } else {
      // Já possui cart drawer instanciado, retorna abertura
      CartDrawer.instance.open();
      if (typeof callback === 'function') callback()
    }
  },

  getCartItens: async function () {
    try {
      const response = await fetch('/carrinho/itens');
      const itens = await response.json()
      return itens;

    } catch (error) {
      console.error('Erro ao buscar a quantidade de produtos do carrinho');
      console.error(error);
    }
  },

  updateCartCount: async function (_itemsCount = null) {
    let items = _itemsCount;
    if (_itemsCount == null) items = await CartDrawer.getCartItens();

    this.countWrapper.innerHTML = items;
  },

  init: function () {
    const _this = this;
    const { buttons } = _this;

    // Atualiza o contador de itens do carrinho
    _this.updateCartCount();

    if (buttons.length > 0) buttons.forEach(button => {
      button.addEventListener('click', () => {
        _this.handleCartButton(button)
      })
    })
  },
};

// ===============================================================
// NEWSLETTER POPUP
// ===============================================================
export const NewsletterComponent = {
  root: document.querySelector('#component-popup-newsletter-root'),
  settings: window.popupNewsletterSettings || false,
  loaded: false,

  setPopupNewsletter: function() {

    const { settings, root } = NewsletterComponent

    // Define propriedades do componente
    let maxWidth = settings.maxWidth;
    let imageUrl = settings.imageUrl;
    let title = settings.title;
    let description = settings.description;
    let subdomain = settings.subdomain;
    let successMessage = settings.success;

    // Inicia o componente
    const componentNewsletterPopup = new Vnda.Component.NewsletterPopup({
      maxWidth: maxWidth,
      maxHeight: 500,
      imageUrl: imageUrl,
      imagePosition: 'left',
      popupPosition: 'center',
      title: title,
      description: description,
      textBtnSubmit: 'Enviar',
      classBtnSubmit: 'btn-newsletter',
      formKey: `${subdomain}-newsletter`,
      hasNameField: false,
      hasLastNameField: false,
      hasDateOfBirthField: false,
      hasPhoneField: false,
      successMessage: successMessage,
      delay: 500,
      frequency: '7',
      language: 'pt-BR',
    });

    // Renderiza o componente e marca como carregado
    componentNewsletterPopup.render(root);

    const newsletterRoot = document.getElementById('component-popup-newsletter-root');    
    const htmlDescription = $('[data-popup-newsletter]').data("popupDescription");
    if (newsletterRoot.innerHTML) {
      const textWrapper = document.querySelector('.text-box')
      textWrapper.querySelector('p').innerHTML = htmlDescription;
    }
    
    NewsletterComponent.loaded = true
  },

  loadPopupNewsletter: function() {
    if (!NewsletterComponent.loaded) {
      const { settings } = NewsletterComponent;
      addAsset(settings.script, NewsletterComponent.setPopupNewsletter)
      addAsset(settings.styles)
    }
  },

  init: function() {
    const { root, settings } = this;

    if (!root || !settings) return;

    const eventType = (window.innerWidth <= 1024) ? 'scroll' : 'mousemove'
    window.addEventListener(eventType, () => {
      NewsletterComponent.loadPopupNewsletter()
    }, { once: true })
  }
}

// ===============================================================
// FILTROS
// ===============================================================
export function setFilters() {
  window.addEventListener('load', () => {

    // Seleciona o elemento
    const root = document.querySelector('#component-products-filter-vertical-root');

    // Define filtros de categoria
    let tags = aggregations.types.categoria && [{
      title: "Categoria",
      type: "categoria",
      style: "list",
      options: aggregations.types.categoria
    }];

    // Define filtros do primeiro atributo
    let property1 = aggregations.properties.property1.length > 0 && {
      title: "Cor",
      property: "property1",
      style: "colors",
      colorsProps: {
        showTitle: false,
        showColor: true,
      },
      options: aggregations.properties.property1,
    };

    // Ordena tamanhos
    const sizesOrder = ['pp', 'p', 'm', 'g', 'gg', 'xg'];
    const sizes = aggregations.properties.property2;
    const newSizes = sizes.sort((optionA, optionB) => {
      return sizesOrder.indexOf(optionA.value.toLowerCase()) - sizesOrder.indexOf(optionB.value.toLowerCase());
    });

    // Define filtros do segundo atributo
    let property2 = aggregations.properties.property2.length > 0 && {
      title: "Tamanho",
      property: "property2",
      style: "grid",
      gridProps: {
        columns: 4
      },
      options: newSizes,
    };

    // Define filtros do terceiro atributo
    let property3 = aggregations.properties.property3.length > 0 && {
      title: "Tecido",
      property: "property3",
      style: "list",
      options: aggregations.properties.property3,
    };

    // Inicia o componente
    const componentFilters = new Vnda.Component.ProductsFilter({
      mode: "vertical",
      hasSort: true,
      filterOnClick: false,
      resetMode: "all",
      // tags type "categoria"
      tags: tags,
      // properties
      properties: [
        // property1,
        // property2,
        // property3,
      ],
      // price
      price: [aggregations.min_price, aggregations.max_price],
    });
    
    // Renderiza o componente
    componentFilters.render(root);

  });
}

// ===============================================================
// LOGIN
// ===============================================================
export function setLogin() {
  window.addEventListener('load', () => {

    // Seleciona o elemento
    const root = document.querySelector('#component-login-static-root');

    // Define link para o Facebook
    let facebook_connect_url = root.getAttribute('data-facebook');

    // Inicia o componente
    window.componentLogin = {}
    window.componentLogin['static'] = new Vnda.Component.Login({
      mode: 'static',
      formProps: {
        login: {
          buttons: {
            facebook: {
              link: facebook_connect_url,
            },
          },
          hasFacebook: false
        },
        register: {
          buttons: {
            facebook: {
              link: facebook_connect_url,
            },
          },
          hasFacebook: false
        }
      }
    });
    
    // Renderiza o componente
    componentLogin['static'].render(root);

  });
}

// ===============================================================
// PREÇO
// ===============================================================
// Carrega o componente de preço quando um product-block ou product-infos entra em tela
export const PriceComponent = {
  script: window.priceComponent || false,
  loaded: false,

  init: function() {

    if (!PriceComponent.script) return;

    const productContainers = document.querySelectorAll('[data-product-box]');

    if (productContainers.length === 0) return;

    const observer = new IntersectionObserver(entries => {
      if (entries[0].isIntersecting) {
        if (!PriceComponent.loaded) {
          addAsset(PriceComponent.script)
          PriceComponent.loaded = true
        }        
        observer.disconnect()
      }
    }, { threshold: 0.1 });

    productContainers.forEach(product => {
      observer.observe(product)
    })
  }

}
